module.exports = __webpack_public_path__ + "media/components/common/formParts/img/dummy-header-e554270f3067f2227f052f6498b3f0cc.png";